

<mce-page-with-navigation>

    <div>
        <mce-project-list></mce-project-list>
    </div>

</mce-page-with-navigation>
